<template>
    <div class="rotate-wrap">
        <div class="main-wrap">
            <img class="icon"
                src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyBjbGFzcz0iaWNvbiIgd2lkdGg9IjIwMHB4IiBoZWlnaHQ9IjIwMC4wMHB4IiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbD0iI2UxZTFlMSIgZD0iTTg2NCA5NjBoLTI1NmE5NiA5NiAwIDAgMS05Ni05NlYxNjBhOTYgOTYgMCAwIDEgOTYtOTZoMjU2YTk2IDk2IDAgMCAxIDk2IDk2djcwNGE5NiA5NiAwIDAgMS05NiA5NnogbTMyLTgwMGEzMiAzMiAwIDAgMC0zMi0zMmgtMjU2YTMyIDMyIDAgMCAwLTMyIDMydjcwNGEzMiAzMiAwIDAgMCAzMiAzMmgyNTZhMzIgMzIgMCAwIDAgMzItMzJWMTYwek02NCA4NjR2LTI1NmE5NiA5NiAwIDAgMSA5Ni05NmgyODh2NjRIMTYwYTMyIDMyIDAgMCAwLTMyIDMydjI1NmEzMiAzMiAwIDAgMCAzMiAzMmgyODh2NjRIMTYwYTk2IDk2IDAgMCAxLTk2LTk2eiBtMjU2LTY0MEgyMjRhMzIgMzIgMCAwIDAtMzIgMzJ2MTkySDEyOFYyNTZhOTYgOTYgMCAwIDEgOTYtOTZoOTZWNjRsMTI4IDEyOC0xMjggMTI4VjIyNHoiICAvPjwvc3ZnPg==" />
            <p>僅支持豎屏,請旋轉你的設備</p>
        </div>
    </div>
</template>
<script>
export default {
    name: "rotate-overlay"
}
</script>
<style lang="scss">
    .rotate-wrap {
        display: none;
    }

    @media (orientation: landscape) and (max-height: 500px){
        .rotate-wrap{
            display: flex;
            position: fixed;
            width: 100vw;
            height: 100vh;
            z-index: 100;
            background-color: rgba(0, 0, 0, 1);
            justify-content: center;
            align-items: center;
            color: white;

            .main-wrap {
                text-align: center;
                width: 80vw;
            }

            .icon {
                width: 30%;
                height: auto;
            }
        }
    }
</style>